import { FC } from 'react'
import { Box } from '@mui/material'
import PageHeading from 'components/atoms/PageHeading'
import { useTranslation } from 'react-i18next'
import KpiTrackerSetupForm from 'components/organisms/forms/KpiTrackerSetupForm'

const KpiTrackerSetupPage: FC<{}> = () => {

  const { t } = useTranslation()

  return (
    <Box px={2}>
      <PageHeading title={t('common.kpi-tracker')} />
      <Box sx={{padding: '30px'}} mb={3}><KpiTrackerSetupForm /></Box>
    </Box>
  )
}
export default KpiTrackerSetupPage
